import React from "react";
import { Avatar, Badge } from "@material-ui/core";
export const CaseRowIcon = ({ item }) => {
    var _a, _b, _c;
    return (React.createElement("div", { className: "CaseRowIndicator" }, ((_a = item.caseAreas) === null || _a === void 0 ? void 0 : _a.length) !== 1 ? (React.createElement(Badge, { color: "primary", overlap: "circle", anchorOrigin: {
            vertical: "top",
            horizontal: "right",
        }, badgeContent: item.caseAreas.length },
        React.createElement(Avatar, null, (_b = item.caseType) === null || _b === void 0 ? void 0 : _b[0]))) : (React.createElement(Avatar, null, (_c = item.caseType) === null || _c === void 0 ? void 0 : _c[0]))));
};
